export class MQ {
	static W980 = '@media (max-width: 980px)';
	static W760 = '@media (max-width: 760px)';
	static W640 = '@media (max-width: 640px)';
	static isMobileWidth = (width: number | undefined) => !!width && width <= 640;
}
